module.exports = __webpack_public_path__ + "img/Gallery_2_18.d6f03f2d.jpeg";